// Module
var code = `<template class="report-widget-properties">
  <span mdc-headline6>"\${widget.name | widgetNameCleanup}" properties</span>
  <div class="report-widget-properties__properties-grid">

    <template repeat.for="pg of propertyGroups">
      <span class="report-widget-properties__properties-group-title">\${pg.group}</span>

      <template repeat.for="p of pg.properties">
        <span class="report-widget-properties__property-label">\${p.label}</span>

        <input if.bind="p.type === WidgetPropertyType.Text" type="text" value.bind="widgetVm[p.name]">

        <input if.bind="p.type === WidgetPropertyType.LargeText" type="text" value.bind="widgetVm[p.name]">

        <input if.bind="p.type === WidgetPropertyType.Number" type="number" value.bind="widgetVm[p.name] | numericFormatter:'0'">

        <span if.bind="p.type === WidgetPropertyType.Boolean">
          <input type="checkbox" checked.bind="widgetVm[p.name] & debounce">
        </span>

        <input if.bind="p.type === WidgetPropertyType.Colour" type="color" value.bind="widgetVm[p.name] | widgetColor">

        <font-selector if.bind="p.type === WidgetPropertyType.Font" value.bind="widgetVm[p.name] & debounce"></font-selector>

        <select if.bind="p.type === WidgetPropertyType.List" value.bind="widgetVm[p.name]">
          <option repeat.for="lv of p.listValues" model.bind="lv.value">\${lv.label}</option>
        </select>

        <theme-selector if.bind="p.type === WidgetPropertyType.Theme" theme.bind="widgetVm[p.name]"></theme-selector>

        <input type="checkbox" checked.to-view="widgetVm.parameterisedProperties[p.name] !== undefined" change.trigger="parameterisedChanged(p.name, \$event)">
      </template>
    </template>

    <span class="report-widget-properties__properties-group-title">Size</span>

    <span class="report-widget-properties__property-label">X</span>
    <input type="number" value.bind="widget.x | numericFormatter:'0'">
    <span></span>

    <span class="report-widget-properties__property-label">Y</span>
    <input type="number" value.bind="widget.y | numericFormatter:'0'">
    <span></span>

    <span class="report-widget-properties__property-label">Column span</span>
    <input type="number" value.bind="widget.w | numericFormatter:'0'">
    <span></span>

    <span class="report-widget-properties__property-label">Row span</span>
    <input type="number" value.bind="widget.h | numericFormatter:'0'">
    <span></span>

  </div>
  <button mdc-button raised label="Remove" click.delegate="removeWidget(widget)" class="mdc-button--error"></button>

</template>
`;
// Exports
export default code;